import UserNom from '@/generated/controls/user/UserNom.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: UserNom
})
